import { twMerge } from "tailwind-merge";
import { PropsWithAs } from "../types";
import { ForwardedRef } from "react";
import { forwardRefWithGeneric } from "../utils";

export interface CardTitleProps {}

const CardTitle = <T extends React.ElementType = "div">(
  { as, ...props }: PropsWithAs<CardTitleProps, T>,
  ref: ForwardedRef<any>
) => {
  const { className, ...rest } = props;
  const Component = as ?? "div";
  return (
    <Component
      {...rest}
      ref={ref}
      className={twMerge(
        "text-secondary-dark font-medium text-base",
        className
      )}
    />
  );
};

export default forwardRefWithGeneric(CardTitle);
